<app-header></app-header>
<div class="principal-container">
  <div class="second-container">
    <h1 class="principal-title">Mi perfil</h1>
  </div>
  <div class="data-container">
    <mat-accordion class="accordion" multi>
      <div class="usuario">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="title-usuario">
              Datos de usuario
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="usuarioForm">
            <mat-form-field appearance="legacy" class="nombre-empresa">
              <mat-label>Nombres</mat-label>
              <input formControlName="nombres_usuario" matInput type="text" />
            </mat-form-field>
            <mat-form-field appearance="legacy" class="nombre-empresa">
              <mat-label>Apellidos</mat-label>
              <input formControlName="apellidos_usuario" matInput type="text" />
            </mat-form-field>
            <mat-form-field appearance="legacy" class="telefono">
              <mat-label>Teléfono</mat-label>
              <input
                formControlName="telefono_usuario"
                matInput
                type="number"
              />
            </mat-form-field>
            <mat-form-field appearance="legacy" class="email">
              <mat-label>Correo eletrónico</mat-label>
              <input formControlName="correo_usuario" matInput type="email" />
            </mat-form-field>

            <mat-form-field appearance="legacy" class="pais">
              <mat-select formControlName="pais_usuario">
                <mat-option value="null">Seleccione un país</mat-option>
                <mat-option *ngFor="let p of paises" [value]="p.name_es">
                  {{ p.name_es }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="legacy" class="subdominio">
              <mat-label>Fecha de nacimiento</mat-label>
              <input
                formControlName="fecha_de_nacimiento_usuario"
                matInput
                [matDatepicker]="datepicker"
              />
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matSuffix
                [for]="datepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancelar</button>
                  <button mat-raised-button color="primary" matDatepickerApply>
                    Aplicar
                  </button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="legacy" class="password">
              <mat-label>Contraseña</mat-label>
              <input formControlName="clave_usuario" matInput type="password" />
            </mat-form-field>
            <div class="boton-guardar-container">
              <button
                (click)="updateUser(usuarioForm.value)"
                mat-button
                class="btn btn-guardar"
                type="submit"
              >
                Guardar
              </button>
            </div>
          </form>
        </mat-expansion-panel>
      </div>
      <div class="empresa">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="title-empresa">
              Datos de la empresa
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="empresaForm">
            <mat-form-field appearance="legacy" class="nombre-empresa">
              <mat-label>Nombre empresa</mat-label>
              <input
                formControlName="nombre_empresa_usuario"
                matInput
                type="text"
              />
            </mat-form-field>
            <mat-form-field appearance="legacy" class="email">
              <mat-label>Correo eletrónico</mat-label>
              <input
                formControlName="correo_empresa_usuario"
                matInput
                type="email"
              />
            </mat-form-field>
            <mat-form-field appearance="legacy" class="telefono">
              <mat-label>Teléfono</mat-label>
              <input
                formControlName="telefono_empresa_usuario"
                matInput
                type="number"
              />
            </mat-form-field>
            <mat-form-field appearance="legacy" class="subdominio">
              <mat-label>Palabra clave para los eventos (Subdominio)</mat-label>
              <input
                formControlName="subdominio_empresa_usuario"
                matInput
                type="text"
              />
            </mat-form-field>
            <mat-form-field appearance="legacy" class="nombre-empresa">
              <mat-label>¿Subdominio activo?</mat-label>
              <input
                formControlName="cuenta_activa_subdominio"
                matInput
                type="text"
              />
            </mat-form-field>
            <div class="boton-guardar-container">
              <button
                (click)="addUpdateCompany(empresaForm.value, 'add')"
                *ngIf="!empresa"
                mat-button
                class="btn btn-guardar"
                type="submit"
                [disabled]="empresa?.es_demo == 'demo_default'"
              >
                Agregar compañía
              </button>
              <button
                (click)="addUpdateCompany(empresaForm.value, 'update')"
                *ngIf="empresa"
                mat-button
                class="btn btn-guardar"
                type="submit"
                [disabled]="empresa?.es_demo == 'demo_default'"
              >
                Actualizar compañía
              </button>
            </div>
          </form>
        </mat-expansion-panel>
      </div>
      <div class="empresa">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="title-empresa">
              Historial de compras
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row" style="overflow-x: hidden;">
            <div class="col-md-12">
              <div class="card-body text-start">
                <div>
                  <mat-form-field>
                    <mat-label>Buscar transacción</mat-label>
                    <input
                      matInput
                      (keyup)="applyFilterTransaction($event)"
                      #input
                    />
                  </mat-form-field>

                  <table
                    mat-table
                    [dataSource]="dataSourceTrans"
                    class="mat-elevation-z8"
                    matSort
                  >
                    <ng-container matColumnDef="tipo_de_evento">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Tipo de evento
                      </th>
                      <td mat-cell *matCellDef="let transaccion">
                        {{ transaccion.tipo_de_evento }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="valor_transaccion">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Valor Transacción
                      </th>
                      <td mat-cell *matCellDef="let transaccion">
                        {{ transaccion.valor_transaccion }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="plan_comercial">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Plan comercial
                      </th>
                      <td mat-cell *matCellDef="let transaccion">
                        {{ transaccion.plan_comercial }} días
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fecha_registro_transaccion">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Fecha de compra
                      </th>
                      <td mat-cell *matCellDef="let transaccion">
                        {{ transaccion.fecha_registro_transaccion }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="fecha_de_caducidad">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Fecha de caducidad
                      </th>
                      <td mat-cell *matCellDef="let transaccion">
                        {{ transaccion.fecha_de_caducidad }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>Acciones</th>
                      <td mat-cell *matCellDef="let transaccion">
                        <div class="buttons-action">
                          <button class="btn btn-success add-event">
                            Agregar evento
                          </button>
                        </div>
                      </td>
                    </ng-container>
                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumnsTrans"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumnsTrans"
                    ></tr>
                  </table>
                  <mat-paginator
                    [pageSizeOptions]="[5, 10, 20]"
                    showFirstLastButtons
                  ></mat-paginator>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>
</div>
<!-- <app-footer></app-footer> -->
